import { createSelector } from "reselect";

const inspectionSelector = state => state.inspectionJobWorkspace.data;
const inspectionQuotesSelector = state => state.inspectionJobWorkspace.data.inspectionQuotes;
export const jobNoSelector = state =>
    state.inspectionJobWorkspace.data.inspectionJobNoMap
        ? state.inspectionJobWorkspace.data.inspectionJobNoMap.jobNoList.jobNo
        : null;

// eslint-disable-next-line import/prefer-default-export
export const getInspectionJob = createSelector(
    inspectionSelector,
    ({ inspectionFactory, inspectionServiceProviderMaps, inspectionQuotes, ...rest }) => {
        const {
            name,
            address,
            country,
            city,
            nameChi,
            addressChi,
            contactPerson,
            contactPersonEmail,
            contactPersonPhone,
            areaCode,
        } = inspectionFactory || {};
        const serviceProviders =
            !!inspectionQuotes && inspectionQuotes.length > 0
                ? inspectionQuotes.map(lab => lab.companyName)
                : [];

        const selectedServiceProvider =
            !!inspectionQuotes &&
            inspectionQuotes.length > 0 &&
            inspectionQuotes.some(lab => lab.isSelected) &&
            inspectionQuotes.find(lab => lab.isSelected).companyName;
            
        return {
            ...rest,
            inspectionServiceProviderMaps,
            serviceProviders,
            selectedServiceProvider,
            contactDetails: [
                contactPerson,
                contactPersonEmail,
                !!contactPersonPhone ? areaCode : null,
                contactPersonPhone,
            ].filter(Boolean),
            inspectionFactory,
            factoryEN: [name, address, country, city].filter(Boolean),
            factoryCN: [nameChi, addressChi, country, city].filter(Boolean),
        };
    }
);

export const getInspectionQuotes = createSelector(
    inspectionQuotesSelector,
    quotes => ({
        count: quotes.length,
        selectedQuote: quotes.find(({ isSelected }) => !!isSelected),
        quotes: quotes.filter(({ isSelected }) => !isSelected),
    })
);

export const getBasicInfoState = createSelector(
    inspectionSelector,
    ({
        inspectionDate,
        typeOfService: inspectionType,
        criticalLevel,
        criticalMajorLevel: majorLevel,
        criticalMinorLevel: minorLevel,
        budget,
        currency,
        criticalRemark: additionalInfo,
        inspectionServiceProviderMaps,
    }) => ({
        inspectionDetails: {
            inspectionDate,
            inspectionType,
            criticalLevel,
            majorLevel,
            minorLevel,
            budget,
            currency,
            additionalInfo,
        },
        inspectionServiceProviderMaps: {
            serviceProviderIds:
                inspectionServiceProviderMaps &&
                inspectionServiceProviderMaps.length &&
                inspectionServiceProviderMaps.map(e => e.value || null).filter(e => !!e),
        },
    })
);

export const getFactoryState = createSelector(
    inspectionSelector,
    state => ({
        inspectionFactory: {
            name: state.inspectionFactory.name,
            nameChi: state.inspectionFactory.nameChi,
            address: state.inspectionFactory.address,
            addressChi: state.inspectionFactory.addressChi,
            country: state.inspectionFactory.country,
            city: state.inspectionFactory.city,
            contactPerson: state.inspectionFactory.contactPerson,
            contactPersonEmail: state.inspectionFactory.contactPersonEmail,
            contactPersonPhone: state.inspectionFactory.contactPersonPhone,
        },
    })
);

export const getSupplierState = createSelector(
    inspectionSelector,
    state => ({
        inspectionInvoiceAddresses: [
            {
                name: state.supplier.name,
                address: state.supplier.address,
                country: state.supplier.country,
                city: state.supplier.city,
                contactPerson: state.supplier.contactPerson,
                contactPersonEmail: state.supplier.email,
                contactPersonPhone: state.supplier.phone,
                type: "supplierInfo",
            },
        ],
    })
);

export const getBuyerState = createSelector(
    inspectionSelector,
    state => ({
        inspectionInvoiceAddresses: [
            {
                name: state.buyer.name,
                address: state.buyer.address,
                country: state.buyer.country,
                city: state.buyer.city,
                contactPerson: state.buyer.contactPerson,
                contactPersonEmail: state.buyer.email,
                contactPersonPhone: state.buyer.phone,
                type: "buyerInfo",
            },
        ],
    })
);

export const getInspectionField = (state, position) => {
    switch (position) {
        case "basicInfo":
            return getBasicInfoState(state);
        case "factoryInfo":
            return getFactoryState(state);
        case "supplierInfo":
            return getSupplierState(state);
        case "buyerInfo":
            return getBuyerState(state);
        default:
            throw new Error();
    }
};
